import {CurrencyExchange, ManageHistory} from "@mui/icons-material";
import {Badge, Box, IconButton} from "@mui/material";
import {
  getStringFromList,
  getValueOrDash,
} from "../../../helpers/defaultReturnFunction";
import {isOverDue} from "../../../helpers/poStateIdentifier";
import {impexDateFormat} from "../../../manager/dateManager";
import ColouredChip from "../../ColouredChip";
import {dateType} from "./fields";

const poTableCustonCell = ({
  value,
  column: {id},
  row: {original, getToggleRowExpandedProps},
  setSelectedPOForUpdate,
  setSelectedPOForPriceUpdate,
  handleDoubleClick,
}) => {
  if (value) {
    if (dateType.includes(id)) {
      if (isOverDue(original) && id === "duedate") {
        return <ColouredChip label={impexDateFormat(value)} fontSize={10} type={"red"} />;
      } else return impexDateFormat(value);
    } else if (id === "PONumber") {
      return (
        <Box
          onClick={() => handleDoubleClick(original)}
          sx={{color: "#0047ff"}}
        >
          {value}
        </Box>
      );
    } else if (id === "PartNo" && original?.subRows?.length > 1) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-around",
            ml:"5px"
          }}
          {...getToggleRowExpandedProps()}
        >
          <Box
            sx={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100px",
              overflow: "hidden",
              ml:-1
            }}
          >
            {value?.length && value ? getStringFromList(value) : ""}
          </Box>
          {typeof value === "object" && value?.length > 1 && (
            <Badge
              badgeContent={value?.length}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#dceaff",
                  fontSize:"10px"
                },
                
                color: "#1d76ff",
              }}
            />
          )}
        </Box>
      );
    } else return `${value}`;
  } else {
    if (id === "request") {
      return (
        <IconButton
          color="primary"
          sx={{
            ml: 1,
            mr: 1,
            p: "2px",
          }}
          onClick={() => setSelectedPOForUpdate(original)}
        >
          <ManageHistory color="primary" sx={{fontSize:"20px"}}/>
        </IconButton>
      );
    } else if (id === "price_change_request") {
      return (
        <IconButton
          color="primary"
          sx={{
            ml: 1,
            mr: 1,
            p: "2px",
          }}
          onClick={() => setSelectedPOForPriceUpdate(original)}
        >
          <CurrencyExchange fontSize="small" color="primary" />
        </IconButton>
      );
    }
    return `${getValueOrDash(value)}`;
  }
};

export const poDefaultColumn = {
  Cell: poTableCustonCell,
};
